/**
 * Created by boris on 3/31/17.
 */
import {
  SET_REJECTS,
  INITIAL_REJECTS,
  SET_NEXT_REJECTS,
} from '../actions/constants'

const initialState = {
  isLoading:  true,
  users:      new Map(),
  pagination: {},
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INITIAL_REJECTS: {
      return {
        isLoading:  true,
        users:      new Map(),
        pagination: {},
      }
    }

    case SET_REJECTS: {
      let newState = {
        isLoading:  false,
        users:      new Map(),
        pagination: {},
      }
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }
      return newState
    }

    case SET_NEXT_REJECTS: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }

      return newState
    }
    default:
      return state
  }
}
